// extracted by mini-css-extract-plugin
export default {"scriptCard":"scriptCard__Go9vA","header":"header__PvA13","close":"close__WH8Gv","widgetContent":"widgetContent__ExECb"};